import { render, staticRenderFns } from "./StFiltersPagination.vue?vue&type=template&id=da3cacbe&"
import script from "./StFiltersPagination.vue?vue&type=script&lang=js&"
export * from "./StFiltersPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports